import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { LogisticService, BusinesscoItem } from '../../../services/logistic.service';

@Component({
  selector: 'tt-external-api',
  templateUrl: './external-api.component.html',
  styleUrls: ['./external-api.component.css']
})
export class ExternalApiComponent implements OnInit {
    public externalApiKeyno: string;

    public edit?: Edit;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListEdiDestinations: Item[] = [];

    public selectListMethods: Item[] = [];

    public grid?: GridOptions;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.externalApiKeyno = this.stateService.getStateParams()['external_api_keyno'];
    }

    private async loadEdit() {
        if (!!this.externalApiKeyno) {
            this.edit = (await this.datatask.Post(1441, { external_api_keyno: this.externalApiKeyno }))[0];
        }
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadEdiDestinations() {
        this.selectListEdiDestinations = await this.datatask.Post(987);
    }

    private async loadMethods() {
        this.selectListMethods = await this.datatask.Post(1443);
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('external_api_log_grid').setLoadDataFunction({ method: 3480, parameters: () => this.edit }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2221, this.edit))[0];

                if (response?.error_code !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.error_message
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(2222, this.edit))[0];

                    if (response.error_code !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.error_message
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadCompanies();
        this.loadEdiDestinations();
        this.loadMethods();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    businessco_no: string;
    edi_destination_keyno: string;
    external_api_keyno: string;
    external_api_name: string;
    external_api_baseurl: string;
    external_api_auth_method: string;
    external_api_auth_id: string;
    external_api_auth_code: string;
    remarks: string;
}
